const ADMIN = 'ADMIN';

export default {
  ADMIN,
};
